export const environment = {
  production: true,
  test: false,
  imageBaseUrl: 'assets/images/',
  mapbox: {
    accessToken: 'pk.eyJ1IjoibXN0ZmNpbmFyIiwiYSI6ImNrbHQ3bGhjeTIzcDUydnF5c3BvZHE0bm8ifQ.ms7GiuDSI8ZqDI-EFp_D1Q',
  },
  baseApiUrl: 'https://api.doktarim.com/api/',
  baseApiUrlV2: 'https://api.doktarim.com/v2/api/',
  demoUrl: 'https://www.cropmap.com/demo',
  appInsights: {
    instrumentationKey: '24d72e66-9ba9-493f-b1d6-757401b5f6d8',
  },
  testApi: 'https://com-doktarim-api-v3-staging.azurewebsites.net/v2/api/',
};
